import React, { useEffect, useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import './AwaitPaymentStatus.css';
import clock from '../../Assets/clock.gif';
import axiosInstance from '../../Config/axiosConfig';

function AwaitPaymentStatus() {
    const navigate = useNavigate();
    const { state } = useLocation();
    const amount = state?.amount || '0.00';
    const invoiceUid = state?.invoiceUid;
    const [isChecking, setIsChecking] = useState(false);
    const [hasTransId, setHasTransId] = useState(false);

    const checkPaymentStatus = async () => {
        if (!invoiceUid || hasTransId) return;
        
        setIsChecking(true);
        try {
            const response = await axiosInstance.get(
                `Invoice/get-invoice-by-uid/${invoiceUid}`,
                {
                    headers: {
                        "Authorization": `Bearer ${localStorage.getItem("accessToken")}`,
                        "UserDevice": localStorage.getItem("deviceId"),
                        "UserIPAddress": localStorage.getItem("userIp")
                    }
                }
            );

            if (response.data.code === 200 && response.data.data.payment?.trans_id) {
                setHasTransId(true);
                navigate('/payment-status', { 
                    state: { 
                        amount,
                        isSuccess: true,
                        invoiceData: response.data.data,
                        trans_id: response.data.data.payment.trans_id
                    } 
                });
            }
        } catch (error) {
            console.error("Payment check error:", error);
        } finally {
            setIsChecking(false);
        }
    };

    useEffect(() => {
        checkPaymentStatus();
        const intervalId = setInterval(checkPaymentStatus, 5000);
        return () => clearInterval(intervalId);
    }, [invoiceUid, hasTransId]);

    return (
        <div className='await-payment-status-container'>
            <img src={clock} alt='Processing' className='await-payment-status-icon'/>
            <h2>Awaiting Payment</h2>
            <p className='await-payment-status-description-text'>Please wait while we confirm your payment.</p>
            <small className='await-payment-status-description-small'>If not confirmed shortly, check your payment method or contact support.</small>
        </div>
    );
}

export default AwaitPaymentStatus;